import React from 'react'
import BaseLinkButton, { BaseLinkButtonProps } from '../shared/BaseLinkButton'
import s from './LinkButton.module.scss'

export interface LinkButtonProps extends Omit<BaseLinkButtonProps, 'href'> {
  href: string
}

export default function LinkButton({ className, ...props }: LinkButtonProps): React.ReactElement {
  const classes = [s.link, className].filter(Boolean).join(' ')
  return <BaseLinkButton {...props} className={classes} />
}
